module.exports = __webpack_public_path__ + "static/media/bi.20e4b0c8.svg";